import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const CustomVsStandardSoftware9 = props => (
    <ServiceSection noPadTitle singleTitle icon={satelliteIcon} {...props} page="customVsStandardSoftware" section="migrate">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="customVsStandardSoftware:migrate" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default CustomVsStandardSoftware9;
